import Footer from "../include/footer";
import Header from "../include/header";

const Privacy = () => {
    return (<div>
        <Header />
        <div className="content-section">
            <p>ABM Property Management is committed to protecting your privacy and developing technology
                that gives you the most powerful and safe online experience. This Statement of Privacy
                applies to the ABM Property Management site and governs data collection and usage.
                By using the ABM Property Management site, you consent to the data practices described
                in this statement.</p>
            <p><span className="SubHead">Use of Cookies</span></p>
            <p>The ABM Property Management Web site use "cookies" to help you personalize your online
                experience. A cookie is a text file that is placed on your hard disk by a Web page
                server. Cookies cannot be used to run programs or deliver viruses to your computer.
                Cookies are uniquely assigned to you, and can only be read by a web server in the
                domain that issued the cookie to you.</p>
            <p>One of the primary purposes of cookies is to provide a convenience feature to save
                you time. The purpose of a cookie is to tell the Web server that you have returned
                to a specific page. For example, if you personalize ABM Property Management pages, or
                register with ABM Property Management site or services, a cookie helps ABM Property Management
                to recall your specific information on subsequent visits. This simplifies the process
                of recording your personal information, such as billing addresses, shipping addresses,
                and so on. When you return to the same ABM Property Management Web site, the information
                you previously provided can be retrieved, so you can easily use the ABM Property Management
                features that you customized.</p>
            <p>You have the ability to accept or decline cookies. Most Web browsers automatically
                accept cookies, but you can usually modify your browser setting to decline cookies
                if you prefer. If you choose to decline cookies, you may not be able to fully experience
                the interactive features of the ABM Property Management services or Web sites you visit.</p>
            <p><span className="SubHead">Security of your Personal Information</span></p>
            <p>ABM Property Management secures your personal information from unauthorized access,
                use or disclosure. ABM Property Management secures the personally identifiable information
                you provide on computer servers in a controlled, secure environment, protected from
                unauthorized access, use or disclosure. When personal information (such as a credit
                card number) is transmitted to other Web sites, it is protected through the use
                of encryption, such as the Secure Socket Layer (SSL) protocol.</p>
            <p><span className="SubHead">Changes to this Statement</span></p>
            <p>ABM Property Management will occasionally update this Statement of Privacy to reflect
                company and customer feedback. ABM Property Management encourages you to periodically
                review this Statement to be informed of how ABM Property Management is protecting your
                information.</p>
        </div>
        <Footer />
    </div>);
}
export default Privacy;